'use client';

import Image from 'next/image';
import Link from 'next/link';

import { Button } from '@/components/ui/button';
import { usePermission } from '@/lib/contexts/PermissionContext';
import { clearSessionAndRedirect } from '@/lib/utils/session';

/** LPのヘッダー(ロゴ + ログイン / 無料で始める) */
export function SiteHeader() {
  const { isDemo } = usePermission();

  // デモログイン中は token Cookie が残り middleware が /login・/signup を弾くため、
  // 先にデモセッションを破棄してから遷移する。
  const handleAuthNav = (target: string) => (event: React.MouseEvent) => {
    if (isDemo) {
      event.preventDefault();
      void clearSessionAndRedirect(target);
    }
  };

  return (
    <header className="sticky top-0 z-10 border-b border-blue-100 bg-white/80 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 md:px-6">
        <Link href="/" className="flex items-center">
          <Image
            src="/logo.png"
            alt="tes-navi"
            width={1032}
            height={243}
            priority
            className="h-8 w-auto"
          />
        </Link>
        <nav className="flex items-center gap-2">
          <Button variant="ghost" asChild>
            <Link href="/login" onClick={handleAuthNav('/login')}>
              ログイン
            </Link>
          </Button>
          <Button className="bg-blue-600 hover:bg-blue-700" asChild>
            <Link href="/signup" onClick={handleAuthNav('/signup')}>
              無料で始める
            </Link>
          </Button>
        </nav>
      </div>
    </header>
  );
}
